import { Box } from '@mui/material';
import { ReactNode } from 'react';
import { MessageDescriptor } from 'react-intl';
import { SectionCaption } from './SectionCaption';

interface PageSectionProps {
  /** Intl message for the section caption. Prefer this when the copy is extractable. */
  message?: MessageDescriptor;
  /** Optional values interpolated into `message` (e.g. count). */
  values?: Record<string, string | number>;
  /** Pre-rendered title when `message` is omitted. */
  title?: ReactNode;
  children: ReactNode;
}

/**
 * Page-level block: uppercase caption + content + bottom margin.
 * Unlike FormSection, does not stack children with form-field spacing.
 */
export function PageSection({ message, values, title, children }: PageSectionProps) {
  return (
    <Box sx={{ mb: 4 }}>
      <SectionCaption message={message} values={values} title={title} />
      {children}
    </Box>
  );
}
